module.exports = __webpack_public_path__ + "static/media/image-3.2f491811.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/EmailSigs/image-3.png
// module id = 472
// module chunks = 0